import classNames from 'classnames';
import React, { Component } from 'react';
import { Portal } from 'react-portal';
import ThemeContainer from '../ThemeContainer/index';
const KEYCODES = {
    ESCAPE: 27,
};
const ModalContent = ({ closeModal, children, className, theme, outerRef, innerRef, }) => (React.createElement("div", { className: classNames('ixu-modal', className), ref: outerRef },
    React.createElement(ThemeContainer, { theme: theme },
        React.createElement("div", { className: "ixu-modal__inner", ref: innerRef },
            React.createElement("button", { className: "ixu-modal__close-button", onClick: closeModal, tabIndex: 0 }),
            React.createElement("div", { className: "ixu-modal__content" }, typeof children === 'function' ? children({ closeModal }) : children)))));
class Modal extends Component {
    constructor(props) {
        super(props);
        this.modal = null;
        this.modalContent = null;
        this.state = {
            isOpen: this.props.isOpen ?? false,
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleOutsideMouseClick = this.handleOutsideMouseClick.bind(this);
    }
    componentDidMount() {
        if (this.props.isOpen) {
            this.openModal();
        }
        if (!this.props.noCloseOnEsc) {
            document.addEventListener('keydown', this.handleKeydown);
        }
        if (!this.props.noCloseOnClickOutside) {
            document.addEventListener('mousedown', this.handleOutsideMouseClick);
        }
    }
    componentWillUnmount() {
        if (!this.props.noCloseOnEsc) {
            document.removeEventListener('keydown', this.handleKeydown);
        }
        if (!this.props.noCloseOnClickOutside) {
            document.removeEventListener('mousedown', this.handleOutsideMouseClick);
        }
    }
    handleOutsideMouseClick(e) {
        if (!this.state.isOpen) {
            return;
        }
        if (!document.body.contains(e.target) ||
            this.modalContent?.contains(e.target) ||
            (e.button && e.button !== 0)) {
            return;
        }
        this.closeModal();
    }
    handleKeydown(e) {
        if (e.keyCode === KEYCODES.ESCAPE && this.state.isOpen) {
            this.closeModal();
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.isOpen === prevProps.isOpen) {
            return;
        }
        if (this.props.isOpen) {
            this.openModal();
        }
        else {
            this.closeModal();
        }
    }
    openModal(e) {
        if (e && e.nativeEvent) {
            e.nativeEvent.stopImmediatePropagation();
        }
        setTimeout(() => this.modal && this.modal.classList.add('is-open'), 0);
        this.setState({ isOpen: true });
    }
    closeModal() {
        if (this.modal) {
            this.modal.classList.remove('is-open');
            this.modal.addEventListener('transitionend', () => this.setState({ isOpen: false }, this.props.onClose), { once: true });
        }
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.props.trigger && this.props.trigger({ openModal: this.openModal }),
            this.state.isOpen && (React.createElement(Portal, null,
                React.createElement(ModalContent, { ...this.props, closeModal: this.closeModal, innerRef: node => (this.modalContent = node), outerRef: node => (this.modal = node) })))));
    }
}
export default Modal;
//# sourceMappingURL=Modal.js.map